<template>
  <div class="v-navbar-menu">
    <div class="v-nav-left"><router-link
      v-for="(route, index) in leftRoutes"
      :key="index"
      class="navbar-item"
      exact
      :to="route.path">{{ route.leftNavTitle }}</router-link></div>
    <div class="v-nav-right">
      <router-link
        v-for="(route, index) in rightRoutes"
        :key="index"
        class="navbar-item"
        exact
        :to="route.path">{{ route.rightNavTitle }}</router-link>
      <router-link
        v-if="me"
        class="navbar-item"
        exact
        to="#">Hello {{ me.firstName }} !</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "NavMenu",
  props: {
    leftRoutes: Array,
    me: Object,
    logout: Function,
    rightRoutes: Array
  }
};
</script>
<style scoped lang="scss">
.fas:hover {
  cursor: pointer;
}

.v-navbar-menu {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.v-nav-right,
.v-nav-left {
  display: flex;
}
.navbar-item {
  display: flex;
  align-items: center;
}

@media screen and (max-width: 700px) {
  .v-navbar-menu {
    display: none;
  }
}
</style>
